var _style, _g, _g2, _g3, _g4, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _ellipse, _path, _polygon6, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#221F1F;}\r\n\t.st1{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "335.33,83.28 310.71,119.34 267.41,119.34 290.43,83.28  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "327.6,66.56 301.09,66.56 310.29,52.15  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "274.55,83.28 254.16,115.28 233.73,83.28  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "217.85,83.28 240.87,119.34 197.57,119.34 172.98,83.28  "
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "233.73,83.28 254.16,115.28 274.55,83.28 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "197.99,52.15 180.71,66.56 207.19,66.56 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "172.98,83.28 197.57,119.34 240.87,119.34 217.86,83.28 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "327.6,66.56 310.29,52.15 301.09,66.56 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "267.41,119.34 310.71,119.34 335.33,83.28 290.43,83.28 "
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -128.2774 263.6858)",
    className: "st1",
    cx: 254.16,
    cy: 286.69,
    rx: 115.24,
    ry: 115.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317.81,136.47c-19.59-8.32-41.09-12.94-63.65-12.94c-22.59,0-44.1,4.62-63.65,12.94 C132.06,161.34,91,219.29,91,286.69c0,89.95,73.2,163.15,163.15,163.15c89.95,0,163.15-73.2,163.15-163.15 C417.31,219.29,376.22,161.34,317.81,136.47z M254.16,401.93c-63.55,0-115.24-51.69-115.24-115.24 c0-63.55,51.69-115.24,115.24-115.24c63.55,0,115.24,51.69,115.24,115.24C369.4,350.24,317.71,401.93,254.16,401.93z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "285.22,66.56 295.88,49.84 212.4,49.84 223.07,66.56 "
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "197.99,52.15 207.19,66.56 180.71,66.56  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.a999cee3495694a2df540a578d8a4f1e.svg";
export { ForwardRef as ReactComponent };